import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Role} from '../models/entities/role';

@Injectable({providedIn: 'root'})
export class RoleService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  public isAdmin(roleId) {
    return roleId === Role.ROLE_ADMIN;
  }

  public isEmployee(roleId) {
    return roleId === Role.ROLE_EMPLOYEE;
  }

}
